// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import _ from 'lodash';
import classNames from 'classnames';
import Bookmark from '@nerdwallet/react-icon/fontawesome/Bookmark';
import { Text, Box, Link } from '@nerdwallet/currency';
import { stringInputSpec, boolCheckboxSpec } from '../../lib/editing-configs';

const AwardsNavigationBox = ({
  section,
  sectionUrl,
  showTrailingDisc,
  awardsYear,
  index,
  currentCategory,
  size,
}) => {
  const newLayoutYearsList = ['2022', '2024'];
  const isNewLayout = newLayoutYearsList.includes(awardsYear);
  const isSmall = size === 'sm' && isNewLayout;
  const selected = sectionUrl === currentCategory && isNewLayout;
  const bookmark = index === 0 && isNewLayout;
  const isNotBookmark = index !== 0 && isNewLayout;

  const isAnchorLink = (sectionUrl || '').charAt(0) === '#';
  const modifiedUrl = isAnchorLink ? sectionUrl : sectionUrl;
  const url = modifiedUrl;
  const circleIcon = (
    <span className={classNames(['awards-nav__disc', `layout-${awardsYear}`])}>
      &bull;
    </span>
  );

  const sectionSize = isSmall ? 'small' : 'default';

  const bookmarkIcon = (
    <Box
      className={classNames([
        'awards-nav__bookmark',
        `layout-${awardsYear}`,
        {
          selected: selected && bookmark,
        },
      ])}
    >
      <Bookmark />
    </Box>
  );

  const navigationOutput = (
    <Link href={url} className={classNames(['awards-nav__link'])}>
      <Box
        className={classNames([
          'awards-nav__section',
          `layout-${awardsYear}`,
          { selected },
        ])}
      >
        <Text size={sectionSize}>{section}</Text>
      </Box>
    </Link>
  );

  return (
    <div className={classNames(['awards-nav__box', `layout-${awardsYear}`])}>
      {showTrailingDisc && isNotBookmark && circleIcon}
      {bookmark && bookmarkIcon}
      {navigationOutput}
      {showTrailingDisc && !isNewLayout && circleIcon}
    </div>
  );
};

AwardsNavigationBox.propTypes = {
  section: PropTypes.string,
  sectionUrl: PropTypes.string,
  showTrailingDisc: PropTypes.bool,
  awardsYear: PropTypes.string,
  index: PropTypes.string,
  currentCategory: PropTypes.string,
  size: PropTypes.string,
};

AwardsNavigationBox.defaultProps = {
  section: '',
  sectionUrl: '',
  showTrailingDisc: false,
};

AwardsNavigationBox.getEditingConfig = (componentDocument) => {
  const bOaYear = componentDocument?.props?.awardsYear;
  const trailingDiscText =
    bOaYear === '2022' || bOaYear === '2023'
      ? 'Show disc between navigation links?'
      : 'Show trailing disc after navigation link?';
  return [
    stringInputSpec('section', 'Awards section'),
    stringInputSpec('sectionUrl', 'Awards section URL'),
    boolCheckboxSpec('showTrailingDisc', trailingDiscText),
  ];
};

AwardsNavigationBox.displayName = 'AwardsNavigationBox';

export default connect(
  createStructuredSelector({
    size: _.property('mediaQuery'),
  })
)(AwardsNavigationBox);
